export default __webpack_public_path__ + "assets/parking-indoor/tallinn-telliskivi-building.af6d0cbdc0a2a4a72bf22c0393b781a1.webp";